import { useMemo } from "react";

import type { TranscriptUpdate } from "@frontierx/shared/schemas/TranscriptUpdate";

import type { TranscriptSentence } from "../utils/transcriptProcessor";
import { processTranscriptItems } from "../utils/transcriptProcessor";

export function useGroupedTranscript(
  transcript: TranscriptUpdate[],
): TranscriptSentence[] {
  const liveProcessedTranscript = useMemo(() => {
    const processed = processTranscriptItems(transcript);
    return processed;
  }, [transcript]);

  return liveProcessedTranscript;
}
